import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
  },
  add: {
    marginLeft: "auto",
  },
  inputPlaceholder: {
    position: "absolute",
    left: 30,
  },
}));

export default useStyles;
